module.exports = __webpack_public_path__ + "static/media/category1.6a618cb1.svg";